import React from 'react';
import { useSelector } from 'react-redux';
import { customMarkersSelector } from '../markers/state/customMarkersSelector';
import CustomMarker from './CustomMarker';
import { frontStyleLvzSelector } from './state/frontStyleLvzSelector';
import { googleZoomMeetsCustomMarkerMin } from './customMarkerConfig';

function WrapperCustomMarkers({ map }) {
    const customMarkers = useSelector(customMarkersSelector);
    const frontStyleLvz = useSelector(frontStyleLvzSelector);
    const googleZoom = map?.getZoom?.();

    if (
        !map ||
        customMarkers.length === 0 ||
        !googleZoomMeetsCustomMarkerMin(googleZoom)
    ) {
        return null;
    }

    return (
        <>
            {customMarkers.map((marker) => (
                <CustomMarker
                    key={marker.id}
                    googleZoom={googleZoom}
                    frontStyleLvz={frontStyleLvz}
                    position={{ lat: marker.lat, lng: marker.lng }}
                    iconUrl={marker.icon}
                    description={marker.description}
                />
            ))}
        </>
    );
}

export default WrapperCustomMarkers;
